import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

import { FormlyService, MenuService, ScreenSizeService } from '../../../../services';

@Component({
  selector: 'app-formly-horizontal-wrapper',
  templateUrl: './horizontal-wrapper.component.html',
  styleUrl: './horizontal-wrapper.component.scss',
})
export class FormlyHorizontalWrapperComponent extends FieldWrapper {
  constructor(
    public menuService: MenuService,
    public screenSizeService: ScreenSizeService,
    private formlyService: FormlyService,
  ) {
    super();
  }

  get isMobile() {
    return this.formlyService.isMobile;
  }

  get isTextArea(): boolean {
    return this.field.type === 'textarea';
  }
}
